export const GP_APP = 'gp';

export type ReleaseMap = Record<string, string>;

export interface SeenReleaseData {
    lastSeenRelease?: string | null;
    lastSeenReleases?: ReleaseMap;
}

export interface WhatsNewSeenBody {
    version: string;
    app: typeof GP_APP;
}

// Legacy fallback covers a session cached before the backend started returning the map.
export function gpSeenRelease(data: SeenReleaseData | undefined): string | null {
    return (data?.lastSeenReleases?.[GP_APP] ?? data?.lastSeenRelease) || null;
}

export function shouldShowRelease(seen: string | null, release: string): boolean {
    return seen !== release;
}

export function shouldShowOnboarding(seen: string | null): boolean {
    return seen === null;
}

export function gpWhatsNewSeenBody(version: string): WhatsNewSeenBody {
    return { version, app: GP_APP };
}

export function withGpSeenRelease<T extends SeenReleaseData>(
    data: T,
    version: string,
    serverReleases?: ReleaseMap
): T {
    return {
        ...data,
        lastSeenRelease: version,
        lastSeenReleases: serverReleases ?? { ...data.lastSeenReleases, [GP_APP]: version }
    };
}
